import React from 'react';

import { useNavigate } from 'react-router-dom';
import SearchCustomer from './SearchCustomer';
import CustomContainer from '../../components/CustomContainer';
import CustomerFormConfig from './CustomerFormConfig';

const CustomersPage = () => {
  const navigate = useNavigate();

  return (
    <>
      <CustomContainer title={'Baza klientów'}>
        <SearchCustomer
          editable={true}
          removable={true}
          api={'customer'}
          modalSize={'lg'}
          editWithId={true}
          forceDropdown={true}
          creationTitle={'Nowy klient'}
          goToReservations={(id) =>
            navigate('/customer/' + id + '/reservations')
          }
          deleteModalTitle={'Usunięcie klienta'}
          deleteModalDescription={
            'Czy napewno chcesz usunąć wybranego klienta?'
          }
          creationFields={CustomerFormConfig}
          title={'Klienci'}
        />
      </CustomContainer>
    </>
  );
};

export default CustomersPage;
